// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"2f6e250a","370":"ed8a887a","787":"f587e8d5"}[chunkId] + ".chunk.js";
};